import { FlowId, flowId } from "../constants/flowId";
import type { FeConfig } from "@ceeferenderer/fe-renderer-sdk";

type PartialItgConfig = Partial<Omit<FeConfig, "FEProcessName" | "FEProcessGuid">> &
  Required<Pick<FeConfig, "FEProcessName" | "FEProcessGuid">>;

export type FlowConfig = {
  itgConfig: PartialItgConfig;
  queryParamAllowList?: string[];
  queryParams?: Record<string, string>;
  templateId?: string;
};

const flowConfigs: Record<FlowId, FlowConfig> = {
  Retail360_Anticipated_Visits: {
    itgConfig: {
      FEProcessGuid: "a609f52c-261f-415e-8e48-198f2cc24256",
      FEProcessName: "R360_Anticipated_VIsits",
    },
    queryParamAllowList: ["cimaToken", "locId", "deviceType", "environment"],
  },
  Retail360_Anticipated_Visits_Redesign: {
    itgConfig: {
      FEProcessGuid: "0f9ceb95-c7ec-4e30-8985-7563cc885f5d",
      FEProcessName: "R360_Anticipated_Visits_Redesign",
    },
    queryParamAllowList: ["cimaToken", "locId", "deviceType", "environment"],
  },
};

export const flowConfig = flowConfigs[flowId];
